import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

interface MaiaChatRequest {
    jobId: number | null;
    question: string;
}

interface MaiaChatAnswer {
    answer: string;
}

/**
 * MAIA conversational Q&A — `POST /maia/chat`.
 *
 * `jobId` is optional: when the user is mid-wizard on a specific SOV upload,
 * the backend grounds its answer in that job's data (columns, mapping,
 * status); when null (e.g. on the bare entry page), MAIA answers generically.
 */
@Injectable({
    providedIn: "root",
})
export class MaiaChatService {
    constructor(private readonly http: HttpClient) {}

    ask(jobId: number | null, question: string): Observable<MaiaChatAnswer> {
        const payload: MaiaChatRequest = { jobId, question };
        return this.http.post<MaiaChatAnswer>("/maia/chat", payload);
    }
}
